export const CAROUSEL_VARIANTS = ['noImage carousel', 'vertical carousel']
export const NO_PAGINATION_VARIANTS = [
  'vertical no-pagination',
  'featured no-pagination',
  'noImage no-pagination',
]
export const NO_PAGINATE_VARIANTS = [...CAROUSEL_VARIANTS, ...NO_PAGINATION_VARIANTS]

export const cardVariantsMap = {
  'noImage carousel': 'noImage',
  'noImage no-pagination': 'noImage',
  noImage: 'noImage',
  'vertical carousel': 'vertical',
  'vertical no-pagination': 'vertical',
  vertical: 'vertical',
  'featured no-pagination': 'featured',
  featured: 'featured',
  default: undefined,
}
